/**
 * SkylineDivider — the exact line from the Iron Talon Farm logo, rendered
 * as a thin horizontal mark spanning the full width of the page.
 *
 * Use this anywhere you'd normally put a section divider — between sections,
 * above a footer, after a hero — so the brand line quietly recurs across
 * every page.
 *
 *   <SkylineDivider variant="moss" />
 *   <SkylineDivider variant="cream" height={28} opacity={0.6} />
 *
 * Variants:
 *   cream | moss | gold | ink
 */
const VARIANT_SRC = {
  cream: "/brand/skyline-logo-cream.svg",
  moss: "/brand/skyline-logo-moss.svg",
  gold: "/brand/skyline-logo-gold.svg",
  ink: "/brand/skyline-logo-ink.svg",
};

export default function SkylineDivider({
  variant = "moss",
  height = 90,
  opacity = 0.5,
  align = "bottom", // "top" | "bottom"  → which edge the ridge line sits on
  className = "",
  "data-testid": testId,
}) {
  return (
    <div
      aria-hidden="true"
      data-testid={testId || "skyline-divider"}
      className={`relative w-full overflow-hidden pointer-events-none select-none ${className}`}
      style={{ height: `${height}px` }}
    >
      <img
        src={VARIANT_SRC[variant] || VARIANT_SRC.moss}
        alt=""
        className={`block w-full h-full`}
        style={{
          opacity,
          objectFit: "cover", // maintain native aspect — no more squishing on mobile
          objectPosition: align === "top" ? "top" : "bottom",
          transform: align === "top" ? "scaleY(-1)" : "none",
        }}
      />
    </div>
  );
}
